import type { ICustomReport } from '@/Interfaces/ReportBuilder/CustomReport.interface';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import type { CustomReportDownloadFunction } from '@/types/ReportBuilder/GridFunction.types';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import ActionChip from './ActionChip';
import { DurationCell } from './DurationCell';
import StatusChip from './StatusChip';

export const getColumns = (onDownload: CustomReportDownloadFunction): GridColDef[] => [
  {
    field: 'name',
    flex: 4,
    headerName: 'Report Name',
  },
  {
    field: 'createdAt',
    flex: 1,
    headerName: 'Date Generated',
    valueFormatter: value => dateToShortFormat(value),
  },
  {
    field: 'status',
    flex: 1,
    headerName: 'Status',
    align: 'center',
    display: 'flex',
    renderCell: StatusChip,
  },
  {
    field: 'duration',
    flex: 1,
    headerName: 'Duration',
    align: 'center',
    sortable: false,
    display: 'flex',
    renderCell: DurationCell,
  },
  {
    field: 'id',
    flex: 1,
    headerName: 'Action',
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    renderCell: (params: GridRenderCellParams<ICustomReport, number>) => (
      <ActionChip {...params} onDownload={onDownload} />
    ),
    sortable: false,
  },
];
